export default function CatalogFilters({
  categories,
  category,
  loadingCategories,
  onCategoryChange,
  onPriceMinChange,
  onPriceMaxChange,
  onClear,
  hasActiveFilters,
  priceMin,
  priceMax,
  priceRangeInvalid,
}) {
  return (
    <aside className="catalog-filters" aria-label="Filtros do catálogo">
      <div className="catalog-filters__header">
        <h3>Filtros</h3>
        {hasActiveFilters && (
          <button type="button" onClick={onClear}>
            Limpar
          </button>
        )}
      </div>

      <fieldset className="catalog-filter-group">
        <legend>Categoria</legend>
        <label className="catalog-filter-option">
          <input
            checked={!category}
            name="catalog-category"
            onChange={() => onCategoryChange("")}
            type="radio"
          />
          <span>Todas as categorias</span>
        </label>
        {loadingCategories ? (
          <span className="catalog-filters__muted">Carregando...</span>
        ) : (
          categories.map((item) => (
            <label className="catalog-filter-option" key={item.id}>
              <input
                checked={category === item.id}
                name="catalog-category"
                onChange={() => onCategoryChange(item.id)}
                type="radio"
              />
              <span>{item.name}</span>
              <small>{item.productCount}</small>
            </label>
          ))
        )}
      </fieldset>

      <fieldset className="catalog-filter-group">
        <legend>Faixa de preço</legend>
        <div className="catalog-price-range">
          <label className="catalog-price-field">
            <span>Preço mínimo</span>
            <div>
              <span>R$</span>
              <input
                aria-invalid={priceRangeInvalid}
                min="0"
                onChange={(event) => onPriceMinChange(event.target.value)}
                placeholder="0,00"
                step="0.01"
                type="number"
                value={priceMin}
              />
            </div>
          </label>
          <label className="catalog-price-field">
            <span>Preço máximo</span>
            <div>
              <span>R$</span>
              <input
                aria-invalid={priceRangeInvalid}
                min={priceMin || "0"}
                onChange={(event) => onPriceMaxChange(event.target.value)}
                placeholder="0,00"
                step="0.01"
                type="number"
                value={priceMax}
              />
            </div>
          </label>
        </div>
        {priceRangeInvalid && (
          <p className="catalog-filter-error" role="alert">
            O preço máximo deve ser maior ou igual ao preço mínimo.
          </p>
        )}
      </fieldset>
    </aside>
  );
}
